import Main from "./Components/Main";
import React from "react";
import Footer from "./Components/Footer";
import Header from "./Components/Header";

function HomePage() {
  return (
    <>
      <Header />
         <Main/>
      <Footer /> 
    </>
  );
}

export default HomePage;